module.exports = __webpack_public_path__ + "media/images/ic-financeiro-menu-ebe0f238820a49b38a5f58b65d3e7695.svg";